import StoreDetailedReport from "./StoreDetailedReport";

const Vendors: React.FC = () => {
  return <StoreDetailedReport />;
};

export default Vendors;
